import { ReactNode } from "react";
import { Snackbar, CircularProgress } from "@material-ui/core";
import Alert from "./Alert";

interface IProps {
  open: boolean;
  message: ReactNode;
}

const LoadingSnack = ({ open, message }: IProps) => (
  <Snackbar
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "left",
    }}
    open={open}
  >
    <Alert
      type="info"
      icon={<CircularProgress size={"1.5rem"} style={{ color: "white" }} />}
    >
      {message}
    </Alert>
  </Snackbar>
);

export default LoadingSnack;
